export const EMPLOYEE_DOCUMENTS_REQUEST = "employee_documents_request";
export const EMPLOYEE_DOCUMENTS_REQUEST_SUCCESS =
  "employee_documents_request_success";
export const EMPLOYEE_DOCUMENTS_REQUEST_FAILURE =
  "employee_documents_request_failure";
